// extracted by mini-css-extract-plugin
export default {"root":"Scrollindicator--root--3DEkt","isLight":"Scrollindicator--isLight--1ufA8","absolute":"Scrollindicator--absolute--2lwEB"};